import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { getLawInterfaceFromStorage } from 'CorePackage/MainModule/common/getLawInterfaceFromStorage';
import { apiDelete, apiGet } from 'APIPackage/MainModule/common/apiTools';

import { IExportResponse } from '../interfaces/IExportResponse';

export async function fetchExports(page: number, size: number, order?: string): Promise<IExportResponse> {
  const lawInterface = getLawInterfaceFromStorage();
  const params = new URLSearchParams();

  params.set('isFederalLaw248', String(lawInterface === LawInterfacesEnum.FZ_248));
  params.set('page', String(page));
  params.set('size', String(size));
  if (order) {
    params.set('order', order);
  }

  return apiGet<IExportResponse>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/exports?${params}`);
}

export async function fetchExportFileURL(id: number): Promise<string> {
  return apiGet<string>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/exports/${id}/file`);
}

export async function deleteExport(id: number): Promise<void> {
  return apiDelete(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/exports/${id}`);
}
